<div [formGroup]="settingsForm">
  <div class="flex flex-row gap-3">
    <div *ngFor="let field of fields">
      <label class="block font-bold mb-2" [for]="field.id">{{ field.name }}</label>
      <input
        [inputId]="field.id"
        [attr.type]="field.type || 'text'"
        pInputText
        class="w-full p-inputtext"
        [formControlName]="field.id"
      />
    </div>
  </div>

  <div class="flex flex-row gap-3">
    <div *ngFor="let field of filterFields">
      <label class="block font-bold mb-2" [for]="field.id">{{ field.name }}</label>
      <input
        [inputId]="field.id"
        pInputText
        class="w-full p-inputtext"
        [formControlName]="field.id"
      />
    </div>
  </div>
</div>
